import React from 'react';

import Layout from '../components/Layout';

import sports from '../assets/images/running.svg';
import surfing from '../assets/images/browsing.svg';
import music from '../assets/images/music-player.svg';
import gadget from '../assets/images/tablet.svg';
import travel from '../assets/images/trekking.svg';
import bootstrap from '../assets/img/bootstrap.svg';
import docker from '../assets/img/docker.svg';
import express from '../assets/img/express.svg';
import grunt from '../assets/img/grunt.svg';
import jasmine from '../assets/img/jasmine.svg';
import jquery from '../assets/img/jquery.svg';
import knockout from '../assets/img/knockout.svg';
import redux from '../assets/img/redux.svg';
import selenium from '../assets/img/selenium.svg';
import webpack from '../assets/img/webpack.svg';

// import { Link } from 'gatsby';
import Sidebar from '../components/Sidebar';
import config from '../../config';
const IndexPage = () => (
  <Layout>
    <Sidebar />
    <div className="container-fluid p-0">
      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="about"
      >
        <div className="w-100">
          <h1 className="mb-0">
            {config.firstName}
            <span className="text-primary">{config.lastName}</span>
          </h1>
          <div className="subheading mb-5">
            {config.address} · {config.phone} ·
            <a href={`mailto:${config.email}`}>{config.email}</a>
          </div>
          <p className="lead mb-5">
            A Passionate Front End Developer with nearly 4 years of IT
            experience in building web applications for various industries such
            as CRM, Healthcare, Insurance & comms. Expertise in developing
            scalable, responsive, accessible and cross browser web apps using
            HTML5, CSS, JavaScript, Typescript, Jest and using view libraries
            like React JS. Flexible and versatile to adapt to new environments
            and technologies. Strong communication, interpersonal, learning and
            organizing skills matched with the ability to manage the stress and
            time effectively. Worked under scrum agile methodology.
          </p>
          <div className="social-icons">
            {config.socialLinks.map(social => {
              const { icon, url } = social;
              return (
                <a
                  key={url}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className={`fab ${icon}`}></i>
                </a>
              );
            })}
          </div>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="skills"
      >
        <div className="w-100">
          <h2 className="mb-5">Skills</h2>

          <div className="subheading mb-3">
            Programming Languages &amp; Tools
          </div>
          <ul className="list-inline dev-icons">
            <li className="list-inline-item html">
              <a
                href="https://www.w3schools.com/html/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="0.71em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 256 361"
                >
                  <path
                    d="M255.555 70.766l-23.241 260.36l-104.47 28.962l-104.182-28.922L.445 70.766h255.11z"
                    fill="#E44D26"
                  />
                  <path
                    d="M128 337.95l84.417-23.403l19.86-222.49H128V337.95z"
                    fill="#F16529"
                  />
                  <path
                    d="M82.82 155.932H128v-31.937H47.917l.764 8.568l7.85 88.01H128v-31.937H85.739l-2.919-32.704z"
                    fill="#EBEBEB"
                  />
                  <path
                    d="M90.018 236.542h-32.06l4.474 50.146l65.421 18.16l.147-.04V271.58l-.14.037l-35.568-9.604l-2.274-25.471z"
                    fill="#EBEBEB"
                  />
                  <path
                    d="M24.18 0h16.23v16.035h14.847V0h16.231v48.558h-16.23v-16.26H40.411v16.26h-16.23V0z"
                    fill="#000"
                  />
                  <path
                    d="M92.83 16.103H78.544V0h44.814v16.103h-14.295v32.455h-16.23V16.103h-.001z"
                    fill="#000"
                  />
                  <path
                    d="M130.47 0h16.923l10.41 17.062L168.203 0h16.93v48.558h-16.164V24.49l-11.166 17.265h-.28L146.35 24.49v24.068h-15.88V0z"
                    fill="#000"
                  />
                  <path
                    d="M193.21 0h16.235v32.508h22.824v16.05h-39.06V0z"
                    fill="#000"
                  />
                  <path
                    d="M127.89 220.573h39.327l-3.708 41.42l-35.62 9.614v33.226l65.473-18.145l.48-5.396l7.506-84.08l.779-8.576H127.89v31.937z"
                    fill="#FFF"
                  />
                  <path
                    d="M127.89 155.854v.078h77.143l.64-7.178l1.456-16.191l.763-8.568H127.89v31.86z"
                    fill="#FFF"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="256"
                    height="361"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item css">
              <a
                href="https://www.w3schools.com/css/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="0.71em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 256 361"
                >
                  <path
                    d="M127.844 360.088L23.662 331.166L.445 70.766h255.11l-23.241 260.36l-104.47 28.962z"
                    fill="#264DE4"
                  />
                  <path
                    d="M212.417 314.547l19.86-222.49H128V337.95l84.417-23.403z"
                    fill="#2965F1"
                  />
                  <path
                    d="M53.669 188.636l2.862 31.937H128v-31.937H53.669z"
                    fill="#EBEBEB"
                  />
                  <path
                    d="M47.917 123.995l2.903 31.937H128v-31.937H47.917z"
                    fill="#EBEBEB"
                  />
                  <path
                    d="M128 271.58l-.14.037l-35.568-9.604l-2.274-25.471h-32.06l4.474 50.146l65.421 18.16l.147-.04V271.58z"
                    fill="#EBEBEB"
                  />
                  <path
                    d="M60.484 0h38.68v16.176H76.66v16.176h22.506v16.175H60.484V0z"
                    fill="#000"
                  />
                  <path
                    d="M106.901 0h38.681v14.066h-22.505v2.813h22.505v32.352h-38.68V34.46h22.505v-2.813H106.9V0z"
                    fill="#000"
                  />
                  <path
                    d="M153.319 0H192v14.066h-22.505v2.813H192v32.352h-38.681V34.46h22.505v-2.813H153.32V0z"
                    fill="#000"
                  />
                  <path
                    d="M202.127 188.636l5.765-64.641H127.89v31.937h45.002l-2.906 32.704H127.89v31.937h39.327l-3.708 41.42l-35.62 9.614v33.226l65.473-18.145l.48-5.396l7.506-84.08l.779-8.576z"
                    fill="#FFF"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="256"
                    height="361"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item javascript">
              <a
                href="https://www.w3schools.com/js/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 256 256"
                >
                  <path d="M0 0h256v256H0V0z" fill="#F7DF1E" />
                  <path
                    d="M67.312 213.932l19.59-11.856c3.78 6.701 7.218 12.371 15.465 12.371c7.905 0 12.89-3.092 12.89-15.12v-81.798h24.057v82.138c0 24.917-14.606 36.259-35.916 36.259c-19.245 0-30.416-9.967-36.087-21.996"
                    fill="#000"
                  />
                  <path
                    d="M152.381 211.354l19.588-11.341c5.157 8.421 11.859 14.607 23.715 14.607c9.969 0 16.325-4.984 16.325-11.858c0-8.248-6.53-11.17-17.528-15.98l-6.013-2.58c-17.357-7.387-28.87-16.667-28.87-36.257c0-18.044 13.747-31.792 35.228-31.792c15.294 0 26.292 5.328 34.196 19.247L210.29 147.43c-4.125-7.389-8.591-10.31-15.465-10.31c-7.046 0-11.514 4.468-11.514 10.31c0 7.217 4.468 10.14 14.778 14.608l6.014 2.577c20.45 8.765 31.963 17.7 31.963 37.804c0 21.654-17.012 33.51-39.867 33.51c-22.339 0-36.774-10.654-43.819-24.574"
                    fill="#000"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="256"
                    height="256"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item sass">
              <a
                href="https://sass-lang.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="1.34em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 256 192"
                >
                  <path
                    d="M220.281 110.514c-8.906.046-16.647 2.191-23.128 5.362c-2.379-4.71-4.757-8.906-5.176-11.984c-.467-3.59-1.026-5.782-.467-10.072c.56-4.29 3.078-10.399 3.031-10.865c-.046-.466-.56-2.658-5.689-2.704c-5.129-.047-9.559.979-10.072 2.331c-.513 1.352-1.492 4.43-2.145 7.6c-.886 4.664-10.258 21.31-15.62 30.03c-1.726-3.403-3.218-6.388-3.545-8.766c-.466-3.59-1.026-5.782-.466-10.072c.56-4.29 3.078-10.398 3.031-10.865c-.047-.466-.56-2.658-5.689-2.704c-5.13-.047-9.56.979-10.072 2.331c-.513 1.353-1.073 4.523-2.145 7.601c-1.073 3.078-13.523 30.87-16.787 38.05a214.726 214.726 0 0 1-4.15 8.627s-.047.14-.187.373a117.773 117.773 0 0 1-1.398 2.658v.046c-.7 1.26-1.446 2.425-1.819 2.425c-.28 0-.793-3.357.093-7.927c1.865-9.652 6.295-24.667 6.249-25.18c0-.28.839-2.891-2.891-4.244c-3.638-1.352-4.943.886-5.27.886c-.326 0-.56.793-.56.793s4.058-16.88-7.74-16.88c-7.367 0-17.533 8.067-22.569 15.341a6269.96 6269.96 0 0 0-17.16 9.373c-2.75 1.539-5.595 3.078-8.253 4.523c-.187-.186-.373-.42-.56-.606c-14.269-15.248-40.661-26.02-39.542-46.49c.42-7.461 2.984-27.046 50.687-50.827c39.262-19.352 70.505-13.99 75.914-2.099c7.74 16.974-16.74 48.496-57.309 53.065c-15.481 1.726-23.595-4.243-25.646-6.481c-2.145-2.332-2.472-2.472-3.265-2.005c-1.305.7-.466 2.798 0 4.01c1.213 3.17 6.202 8.766 14.642 11.518c7.461 2.424 25.6 3.777 47.563-4.71c24.574-9.513 43.786-35.952 38.144-58.101c-5.643-22.476-42.947-29.89-78.246-17.347C61.086 13.99 38.33 25.74 21.963 41.035C2.518 59.22-.56 75.028.699 81.65c4.524 23.501 36.932 38.796 49.895 50.127c-.653.373-1.26.7-1.772.98c-6.482 3.217-31.196 16.133-37.351 29.796c-6.994 15.481 1.12 26.58 6.482 28.071c16.647 4.617 33.76-3.683 42.946-17.393c9.186-13.709 8.067-31.522 3.824-39.682c-.047-.093-.093-.187-.187-.28c1.679-.979 3.404-2.005 5.083-2.984a247.933 247.933 0 0 1 9.373-5.27c-1.586 4.337-2.752 9.513-3.311 16.974c-.7 8.767 2.89 20.144 7.6 24.62c2.099 1.96 4.57 2.006 6.156 2.006c5.502 0 7.974-4.57 10.725-9.979c3.357-6.621 6.388-14.315 6.388-14.315s-3.777 20.797 6.482 20.797c3.73 0 7.507-4.85 9.186-7.321v.046s.093-.14.28-.466c.373-.606.606-.98.606-.98v-.092c1.492-2.612 4.85-8.534 9.839-18.373c6.435-12.683 12.637-28.537 12.637-28.537s.56 3.87 2.471 10.305c1.12 3.777 3.45 7.927 5.316 11.937c-1.492 2.099-2.425 3.264-2.425 3.264l.047.047c-1.213 1.585-2.518 3.31-3.964 4.99c-5.083 6.061-11.144 13.01-11.984 15.014c-.98 2.378-.746 4.104 1.12 5.503c1.352 1.026 3.776 1.165 6.248 1.026c4.57-.327 7.787-1.446 9.372-2.145c2.472-.886 5.363-2.239 8.067-4.244c4.99-3.684 8.02-8.953 7.741-15.9c-.14-3.824-1.399-7.648-2.938-11.239c.467-.652.886-1.305 1.353-1.958c7.88-11.518 13.989-24.155 13.989-24.155s.56 3.87 2.471 10.306c.933 3.264 2.845 6.808 4.523 10.258c-7.414 6.016-11.984 13.01-13.616 17.58c-2.937 8.487-.653 12.31 3.684 13.196c1.958.42 4.756-.513 6.808-1.399c2.611-.839 5.689-2.284 8.627-4.43c4.99-3.683 9.792-8.813 9.512-15.76c-.14-3.171-.979-6.296-2.145-9.327c6.295-2.61 14.409-4.056 24.76-2.844c22.197 2.611 26.58 16.46 25.74 22.29c-.839 5.828-5.502 8.999-7.04 9.978c-1.54.98-2.052 1.306-1.912 2.005c.186 1.026.932.98 2.238.793c1.819-.326 11.658-4.71 12.077-15.435c.7-13.709-12.357-28.677-35.439-28.537zM49.055 168.242c-7.368 8.02-17.626 11.051-22.056 8.487c-4.756-2.752-2.891-14.596 6.155-23.082c5.502-5.176 12.59-9.98 17.3-12.917c1.072-.653 2.658-1.585 4.57-2.751c.326-.187.513-.28.513-.28l1.119-.7c3.31 12.124.14 22.803-7.601 31.243zm53.625-36.465c-2.565 6.249-7.927 22.243-11.191 21.357c-2.798-.746-4.524-12.87-.56-24.854c2.005-6.016 6.248-13.197 8.72-15.994c4.01-4.477 8.44-5.97 9.512-4.15c1.353 2.378-4.896 19.724-6.481 23.641zm44.252 21.17c-1.073.56-2.098.933-2.565.653c-.326-.187.467-.933.467-.933s5.549-5.968 7.74-8.673c1.26-1.585 2.751-3.45 4.337-5.549v.606c0 7.135-6.902 11.938-9.98 13.896zm34.133-7.787c-.793-.56-.653-2.425 2.005-8.254c1.026-2.285 3.45-6.108 7.601-9.792c.466 1.492.793 2.938.746 4.29c-.047 9-6.481 12.357-10.352 13.756z"
                    fill="#CD6799"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="256"
                    height="192"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item react">
              <a
                href="https://reactjs.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="1.13em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 256 228"
                >
                  <path
                    d="M210.483 73.824a171.49 171.49 0 0 0-8.24-2.597c.465-1.9.893-3.777 1.273-5.621c6.238-30.281 2.16-54.676-11.769-62.708c-13.355-7.7-35.196.329-57.254 19.526a171.23 171.23 0 0 0-6.375 5.848a155.866 155.866 0 0 0-4.241-3.917C100.759 3.829 77.587-4.822 63.673 3.233C50.33 10.957 46.379 33.89 51.995 62.588a170.974 170.974 0 0 0 1.892 8.48c-3.28.932-6.445 1.924-9.474 2.98C17.309 83.498 0 98.307 0 113.668c0 15.865 18.582 31.778 46.812 41.427a145.52 145.52 0 0 0 6.921 2.165a167.467 167.467 0 0 0-2.01 9.138c-5.354 28.2-1.173 50.591 12.134 58.266c13.744 7.926 36.812-.22 59.273-19.855a145.567 145.567 0 0 0 5.342-4.923a168.064 168.064 0 0 0 6.92 6.314c21.758 18.722 43.246 26.282 56.54 18.586c13.731-7.949 18.194-32.003 12.4-61.268a145.016 145.016 0 0 0-1.535-6.842c1.62-.48 3.21-.974 4.76-1.488c29.348-9.723 48.443-25.443 48.443-41.52c0-15.417-17.868-30.326-45.517-39.844zm-6.365 70.984c-1.4.463-2.836.91-4.3 1.345c-3.24-10.257-7.612-21.163-12.963-32.432c5.106-11 9.31-21.767 12.459-31.957c2.619.758 5.16 1.557 7.61 2.4c23.69 8.156 38.14 20.213 38.14 29.504c0 9.896-15.606 22.743-40.946 31.14zm-10.514 20.834c2.562 12.94 2.927 24.64 1.23 33.787c-1.524 8.219-4.59 13.698-8.382 15.893c-8.067 4.67-25.32-1.4-43.927-17.412a156.726 156.726 0 0 1-6.437-5.87c7.214-7.889 14.423-17.06 21.459-27.246c12.376-1.098 24.068-2.894 34.671-5.345c.522 2.107.986 4.173 1.386 6.193zM87.276 214.515c-7.882 2.783-14.16 2.863-17.955.675c-8.075-4.657-11.432-22.636-6.853-46.752a156.923 156.923 0 0 1 1.869-8.499c10.486 2.32 22.093 3.988 34.498 4.994c7.084 9.967 14.501 19.128 21.976 27.15a134.668 134.668 0 0 1-4.877 4.492c-9.933 8.682-19.886 14.842-28.658 17.94zM50.35 144.747c-12.483-4.267-22.792-9.812-29.858-15.863c-6.35-5.437-9.555-10.836-9.555-15.216c0-9.322 13.897-21.212 37.076-29.293c2.813-.98 5.757-1.905 8.812-2.773c3.204 10.42 7.406 21.315 12.477 32.332c-5.137 11.18-9.399 22.249-12.634 32.792a134.718 134.718 0 0 1-6.318-1.979zm12.378-84.26c-4.811-24.587-1.616-43.134 6.425-47.789c8.564-4.958 27.502 2.111 47.463 19.835a144.318 144.318 0 0 1 3.841 3.545c-7.438 7.987-14.787 17.08-21.808 26.988c-12.04 1.116-23.565 2.908-34.161 5.309a160.342 160.342 0 0 1-1.76-7.887zm110.427 27.268a347.8 347.8 0 0 0-7.785-12.803c8.168 1.033 15.994 2.404 23.343 4.08c-2.206 7.072-4.956 14.465-8.193 22.045a381.151 381.151 0 0 0-7.365-13.322zm-45.032-43.861c5.044 5.465 10.096 11.566 15.065 18.186a322.04 322.04 0 0 0-30.257-.006c4.974-6.559 10.069-12.652 15.192-18.18zM82.802 87.83a323.167 323.167 0 0 0-7.227 13.238c-3.184-7.553-5.909-14.98-8.134-22.152c7.304-1.634 15.093-2.97 23.209-3.984a321.524 321.524 0 0 0-7.848 12.897zm8.081 65.352c-8.385-.936-16.291-2.203-23.593-3.793c2.26-7.3 5.045-14.885 8.298-22.6a321.187 321.187 0 0 0 7.257 13.246c2.594 4.48 5.28 8.868 8.038 13.147zm37.542 31.03c-5.184-5.592-10.354-11.779-15.403-18.433c4.902.192 9.899.29 14.978.29c5.218 0 10.376-.117 15.453-.343c-4.985 6.774-10.018 12.97-15.028 18.486zm52.198-57.817c3.422 7.8 6.306 15.345 8.596 22.52c-7.422 1.694-15.436 3.058-23.88 4.071a382.417 382.417 0 0 0 7.859-13.026a347.403 347.403 0 0 0 7.425-13.565zm-16.898 8.101a358.557 358.557 0 0 1-12.281 19.815a329.4 329.4 0 0 1-23.444.823c-7.967 0-15.716-.248-23.178-.732a310.202 310.202 0 0 1-12.513-19.846h.001a307.41 307.41 0 0 1-10.923-20.627a310.278 310.278 0 0 1 10.89-20.637l-.001.001a307.318 307.318 0 0 1 12.413-19.761c7.613-.576 15.42-.876 23.31-.876H128c7.926 0 15.743.303 23.354.883a329.357 329.357 0 0 1 12.335 19.695a358.489 358.489 0 0 1 11.036 20.54a329.472 329.472 0 0 1-11 20.722zm22.56-122.124c8.572 4.944 11.906 24.881 6.52 51.026c-.344 1.668-.73 3.367-1.15 5.09c-10.622-2.452-22.155-4.275-34.23-5.408c-7.034-10.017-14.323-19.124-21.64-27.008a160.789 160.789 0 0 1 5.888-5.4c18.9-16.447 36.564-22.941 44.612-18.3zM128 90.808c12.625 0 22.86 10.235 22.86 22.86s-10.235 22.86-22.86 22.86s-22.86-10.235-22.86-22.86s10.235-22.86 22.86-22.86z"
                    fill="#00D8FF"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="256"
                    height="228"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item typescript">
              <a
                href="https://www.typescriptlang.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 256 256"
                >
                  <path fill="#007ACC" d="M0 128v128h256V0H0z" />
                  <path
                    d="M56.611 128.85l-.081 10.483h33.32v94.68H113.42v-94.68h33.32v-10.28c0-5.69-.122-10.444-.284-10.566c-.122-.162-20.399-.244-44.983-.203l-44.739.122l-.122 10.443z"
                    fill="#FFF"
                  />
                  <path
                    d="M206.567 118.108c6.501 1.626 11.459 4.51 16.01 9.224c2.357 2.52 5.851 7.112 6.136 8.209c.08.325-11.053 7.802-17.798 11.987c-.244.163-1.22-.894-2.317-2.52c-3.291-4.794-6.745-6.867-12.028-7.232c-7.76-.529-12.759 3.535-12.718 10.32c0 1.992.284 3.17 1.097 4.796c1.707 3.535 4.876 5.648 14.832 9.955c18.326 7.884 26.168 13.085 31.045 20.48c5.445 8.25 6.664 21.415 2.966 31.208c-4.063 10.646-14.14 17.88-28.323 20.277c-4.388.772-14.79.65-19.504-.203c-10.28-1.829-20.033-6.908-26.047-13.572c-2.357-2.601-6.949-9.387-6.664-9.875c.122-.162 1.178-.812 2.356-1.503c1.138-.65 5.446-3.13 9.509-5.486l7.355-4.267l1.544 2.276c2.154 3.291 6.867 7.802 9.712 9.305c8.167 4.308 19.383 3.698 24.909-1.26c2.357-2.153 3.332-4.388 3.332-7.68c0-2.966-.366-4.266-1.91-6.5c-1.99-2.845-6.054-5.243-17.595-10.24c-13.206-5.69-18.895-9.225-24.096-14.833c-3.007-3.25-5.852-8.452-7.03-12.8c-.975-3.616-1.22-12.678-.447-16.335c2.723-12.76 12.353-21.658 26.25-24.3c4.51-.853 14.994-.528 19.424.57z"
                    fill="#FFF"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="256"
                    height="256"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item styledcomponents">
              <a
                href="https://styled-components.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M16.214 6.762l-.075.391c-.116.741-.074.953.244 1.228l.307.254l-.318 1.418c-.19.846-.423 1.555-.571 1.788c-.127.201-.275.497-.307.656c-.053.19-.233.381-.508.55c-.243.138-.72.508-1.058.805c-.27.243-.456.392-.557.456l-.33.261a1.4 1.4 0 0 0-.189.411c-.023.107-.01.178.024.23c.033.05.09.085.168.107a.954.954 0 0 0 .282.023a3 3 0 0 0 .632-.112c.07-.019.125-.037.173-.053c.074-.091.245-.263.548-.562c.804-.793 1.111-1.227.794-1.11c-.117.042-.064-.064.137-.276c.424-.413.667-1.037 1.175-2.994c.402-1.545.402-1.567.698-1.567c.139 0 .532.024.532.024V6.762h-.902zm3.839 3.165c-.064 0-.17.096-.233.202c-.116.19.021.306 1.767 1.396c1.037.657 1.873 1.217 1.852 1.26c-.021.031-.868.582-1.883 1.217c-1.842 1.142-1.852 1.153-1.683 1.386c.212.275 0 .37 2.391-1.122L24 13.155v-.836l-1.937-1.196c-1.047-.656-1.957-1.185-2.01-1.196zm-16.085.117c-.053 0-.963.54-2.01 1.185L0 12.425v.836l1.947 1.217c1.08.666 1.99 1.217 2.032 1.217c.042 0 .127-.096.212-.212c.127-.201.02-.286-1.768-1.418C.72 12.996.54 12.848.71 12.732c.106-.074.91-.572 1.778-1.111c1.979-1.217 1.873-1.133 1.714-1.387c-.063-.105-.17-.2-.233-.19zm8.684.023c-.292-.002-.92.443-2.8 1.978c-.081.193-.088.326-.051.412c.024.059.068.1.129.13c.06.03.138.048.224.055c.171.015.373-.012.536-.044l.11-.025a.386.386 0 0 1 .144-.118c.116-.064.603-.508 1.09-.984c.857-.868 1.058-1.26.709-1.387a.24.24 0 0 0-.09-.017zm2.196.603c-.257.007-.72.305-1.513.938c-.398.323-.65.497-.785.533l-.524.414c-.197.36-.226.583-.174.706a.25.25 0 0 0 .138.134a.644.644 0 0 0 .24.045a2.18 2.18 0 0 0 .58-.085a3.466 3.466 0 0 0 .291-.092l.029-.012l.053-.028c.1-.129.33-.372.618-.652c.91-.878 1.375-1.502 1.28-1.735c-.043-.113-.117-.17-.233-.166zm-2.424 1.08c-.074.008-.24.136-.539.398c-.432.382-.903.602-1.066.504a3.97 3.97 0 0 1-.114.024c-.166.033-.373.06-.558.045a.708.708 0 0 1-.252-.063a.337.337 0 0 1-.168-.17c-.037-.09-.037-.202.005-.345l-.65.534l-1.471 1.217v1.973l4.82-3.797a.41.41 0 0 1 .016-.123c.037-.134.035-.202-.023-.196zm2.074.639c-.073 0-.195.103-.39.31c-.265.283-.682.557-.903.613l-.034.018a2.191 2.191 0 0 1-.11.042c-.06.02-.138.044-.228.068c-.18.049-.404.094-.604.089a.732.732 0 0 1-.275-.054a.344.344 0 0 1-.184-.18c-.058-.139-.035-.334.092-.611L7.61 16.033v1.205h1.868l3.962-3.112c.103-.114.258-.27.467-.465c.56-.519.687-.698.687-.963c0-.206-.023-.31-.096-.31zm.943 1.95l-.339.338c-.19.18-.529.402-.761.497l-.046.02l-.003.005l-.01.01c-.009.007-.013.008-.02.011a3.432 3.432 0 0 1-.282.093a3.058 3.058 0 0 1-.65.115a1.035 1.035 0 0 1-.31-.027a.364.364 0 0 1-.218-.144c-.048-.074-.062-.173-.035-.295a1.11 1.11 0 0 1 .095-.25l-3.197 2.526h4.252l.508-.582c.698-.814 1.016-1.396 1.016-1.894z"
                    fill="#fff"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item jest">
              <a
                href="https://jestjs.io/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="0.91em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 256 283"
                >
                  <path
                    d="M239.553 138.96c0-14.508-11.762-26.27-26.27-26.27c-.934 0-1.854.05-2.762.146l36.082-106.42H93.267l36.032 106.327a26.318 26.318 0 0 0-1.597-.052c-14.508 0-26.27 11.76-26.27 26.27c0 11.727 7.686 21.656 18.293 25.034c-5.602 9.704-12.652 18.445-20.656 25.997c-10.884 10.267-23.34 18.053-36.812 22.85c-16.04-8.24-23.614-26.565-16.78-42.632c.772-1.815 1.56-3.654 2.313-5.485c11.62-2.712 20.28-13.129 20.28-25.576c0-14.509-11.762-26.27-26.271-26.27s-26.27 11.761-26.27 26.27c0 8.897 4.426 16.756 11.193 21.508c-6.502 14.804-16.06 30.298-19.038 48.255c-3.569 21.52-.012 44.364 18.601 57.265c43.348 30.044 90.402-18.625 140.014-30.86c17.98-4.433 37.717-3.719 53.558-12.893c11.896-6.89 19.739-18.309 21.964-31.128c2.2-12.664-1.006-25.273-8.378-35.497a26.158 26.158 0 0 0 6.11-16.839"
                    fill="#99425B"
                  />
                  <path
                    d="M235.5 190.198c-1.932 11.13-8.806 20.851-18.858 26.674c-9.371 5.427-20.6 7.047-32.49 8.761c-6.369.918-12.955 1.869-19.389 3.455c-17.012 4.195-33.49 12.38-49.424 20.295c-31.89 15.84-59.43 29.518-85.398 11.52c-19.022-13.183-18.144-37.575-15.928-50.941c2.054-12.384 7.607-23.789 12.976-34.818a796.621 796.621 0 0 0 2.722-5.634a32.453 32.453 0 0 0 8.443 2.118c-5.466 18.039 3.13 37.653 21.171 46.921l2.47 1.269l2.614-.931c14.263-5.08 27.406-13.23 39.063-24.229c7.535-7.109 14.014-14.974 19.339-23.378a32.8 32.8 0 0 0 4.891.367c16.559 0 30.271-12.379 32.393-28.367c6.778-.248 13.977-.25 20.794-.002c2.12 15.99 15.834 28.37 32.393 28.37c6.924 0 13.346-2.17 18.637-5.856c3.673 7.519 5.044 15.979 3.581 24.406zM41.8 119.295c10.948 0 19.854 8.907 19.854 19.855c0 3.932-1.154 7.599-3.135 10.687c-3.3 5.147-8.91 8.675-15.355 9.115c-.451.03-.906.052-1.364.052c-2.44 0-4.777-.445-6.938-1.253a19.967 19.967 0 0 1-10.305-8.777a19.725 19.725 0 0 1-2.612-9.824c0-10.948 8.907-19.855 19.855-19.855zm66.049 19.666c0-9.947 7.353-18.206 16.907-19.634c.962-.145 1.946-.22 2.947-.22c6.365 0 12.032 3.015 15.666 7.687a19.88 19.88 0 0 1 2.318 3.765a19.73 19.73 0 0 1 1.87 8.402c0 1.587-.192 3.13-.545 4.61c-1.935 8.1-8.842 14.292-17.306 15.144c-.658.066-1.326.1-2.003.1a19.734 19.734 0 0 1-10.76-3.181c-5.466-3.541-9.094-9.69-9.094-16.673zm82.865-23.61a32.721 32.721 0 0 0-8.991 15.117a304.792 304.792 0 0 0-22.458 0c-1.68-6.232-5.162-11.73-9.847-15.906l20.545-41.542l20.751 42.332zM102.216 12.834h135.437l-31.989 94.345a32.479 32.479 0 0 0-4.051 1.255l-31.6-64.463l-31.69 64.078a32.502 32.502 0 0 0-4.226-1.139l-31.881-94.076zm130.92 126.128c0 1.99-.297 3.912-.844 5.727a19.933 19.933 0 0 1-7.653 10.545a19.74 19.74 0 0 1-11.357 3.582c-9.167 0-16.9-6.247-19.174-14.707a19.803 19.803 0 0 1-.68-5.147c0-2.714.548-5.302 1.538-7.66a19.848 19.848 0 0 1 1.878-3.442c3.573-5.274 9.602-8.752 16.438-8.752c.627 0 1.245.032 1.858.09c10.08.939 17.997 9.442 17.997 19.764zm12.833 0c0-15.958-11.498-29.273-26.642-32.117L255.553 0H84.318L120.6 107.061c-14.618 3.253-25.583 16.316-25.583 31.9c0 11.702 6.184 21.98 15.452 27.756c-4.458 6.642-9.744 12.892-15.802 18.608c-9.608 9.063-20.311 15.937-31.85 20.46c-11.623-7.301-16.536-21.07-11.434-33.064l.4-.94l.75-1.764c12.766-4.453 21.953-16.603 21.953-30.867c0-18.024-14.663-32.687-32.686-32.687c-18.024 0-32.687 14.663-32.687 32.687c0 9.097 3.74 17.335 9.758 23.267a552.73 552.73 0 0 1-3.418 7.11c-5.503 11.301-11.739 24.11-14.098 38.335c-4.684 28.25 2.872 50.833 21.277 63.588c11.168 7.74 22.51 10.784 33.923 10.784c21.49 0 43.23-10.797 64.493-21.359c15.313-7.605 31.148-15.47 46.789-19.328c5.82-1.435 11.808-2.299 18.148-3.213c12.573-1.814 25.573-3.689 37.089-10.358c13.349-7.732 22.486-20.702 25.07-35.582c2.218-12.775-.451-25.57-6.961-36.422a32.488 32.488 0 0 0 4.787-17.011z"
                    fill="#FFF"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="256"
                    height="283"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item storybook">
              <a
                href="https://storybook.js.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 32 32"
                >
                  <path
                    d="M20.735 5.442l.133-3.173l2.72-.168l.122 3.23a.216.216 0 0 1-.047.143a.21.21 0 0 1-.3.029l-1.05-.82l-1.243.934a.212.212 0 0 1-.3-.04a.206.206 0 0 1-.035-.135z"
                    fill="#fff"
                  />
                  <path
                    d="M20.868 2.268l-.133 3.174a.206.206 0 0 0 .043.135a.212.212 0 0 0 .3.04l1.243-.934l1.05.82a.21.21 0 0 0 .3-.029a.216.216 0 0 0 .047-.143l-.13-3.231l1.566-.1a1.415 1.415 0 0 1 1.506 1.321v25.271A1.414 1.414 0 0 1 25.245 30h-.066l-18.948-.844A1.414 1.414 0 0 1 4.876 27.8L4 4.69a1.412 1.412 0 0 1 1.33-1.458l15.537-.963z"
                    fill="#ff4785"
                  />
                  <path
                    d="M17.253 12.554c0 .547 3.72.285 4.22-.1c0-3.73-2.018-5.69-5.714-5.69s-5.766 1.99-5.766 4.976c0 5.2 7.077 5.3 7.077 8.136a1.127 1.127 0 0 1-1.258 1.27c-1.127 0-1.573-.572-1.52-2.512c0-.421-4.3-.553-4.43 0c-.334 4.7 2.621 6.06 6 6.06c3.276 0 5.845-1.733 5.845-4.868c0-5.573-7.182-5.423-7.182-8.185a1.18 1.18 0 0 1 1.337-1.269c.526 0 1.47.092 1.391 2.182z"
                    fill="#fff"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="32"
                    height="32"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item git">
              <a
                href="https://git-scm.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 256 256"
                >
                  <path
                    d="M251.172 116.594L139.4 4.828c-6.433-6.437-16.873-6.437-23.314 0l-23.21 23.21l29.443 29.443c6.842-2.312 14.688-.761 20.142 4.693c5.48 5.489 7.02 13.402 4.652 20.266l28.375 28.376c6.865-2.365 14.786-.835 20.269 4.657c7.663 7.66 7.663 20.075 0 27.74c-7.665 7.666-20.08 7.666-27.749 0c-5.764-5.77-7.188-14.235-4.27-21.336l-26.462-26.462l-.003 69.637a19.82 19.82 0 0 1 5.188 3.71c7.663 7.66 7.663 20.076 0 27.747c-7.665 7.662-20.086 7.662-27.74 0c-7.663-7.671-7.663-20.086 0-27.746a19.654 19.654 0 0 1 6.421-4.281V94.196a19.378 19.378 0 0 1-6.421-4.281c-5.806-5.798-7.202-14.317-4.227-21.446L81.47 39.442l-76.64 76.635c-6.44 6.443-6.44 16.884 0 23.322l111.774 111.768c6.435 6.438 16.873 6.438 23.316 0l111.251-111.249c6.438-6.44 6.438-16.887 0-23.324"
                    fill="#DE4C36"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="256"
                    height="256"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item node">
              <a
                href="https://nodejs.org/en/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 32 32"
                >
                  <path
                    d="M16 30a2.151 2.151 0 0 1-1.076-.288L11.5 27.685c-.511-.286-.262-.387-.093-.446a6.828 6.828 0 0 0 1.549-.7a.263.263 0 0 1 .255.019l2.631 1.563a.34.34 0 0 0 .318 0l10.26-5.922a.323.323 0 0 0 .157-.278V10.075a.331.331 0 0 0-.159-.283l-10.26-5.917a.323.323 0 0 0-.317 0L5.587 9.794a.33.33 0 0 0-.162.281v11.841a.315.315 0 0 0 .161.274L8.4 23.814c1.525.762 2.459-.136 2.459-1.038V11.085a.3.3 0 0 1 .3-.3h1.3a.3.3 0 0 1 .3.3v11.692c0 2.035-1.108 3.2-3.038 3.2a4.389 4.389 0 0 1-2.363-.642l-2.697-1.547a2.166 2.166 0 0 1-1.076-1.872V10.075A2.162 2.162 0 0 1 4.661 8.2l10.261-5.924a2.246 2.246 0 0 1 2.156 0L27.338 8.2a2.165 2.165 0 0 1 1.077 1.87v11.846a2.171 2.171 0 0 1-1.077 1.872l-10.26 5.924A2.152 2.152 0 0 1 16 30z"
                    fill="#83cd29"
                  />
                  <path
                    d="M14.054 17.953a.3.3 0 0 1 .3-.3h1.327a.3.3 0 0 1 .295.251c.2 1.351.8 2.032 3.513 2.032c2.161 0 3.082-.489 3.082-1.636c0-.661-.261-1.152-3.62-1.481c-2.808-.278-4.544-.9-4.544-3.144c0-2.07 1.745-3.305 4.67-3.305c3.287 0 4.914 1.141 5.12 3.589a.3.3 0 0 1-.295.323h-1.336a.3.3 0 0 1-.288-.232c-.319-1.421-1.1-1.875-3.2-1.875c-2.36 0-2.634.822-2.634 1.438c0 .746.324.964 3.51 1.385c3.153.417 4.651 1.007 4.651 3.223c0 2.236-1.864 3.516-5.115 3.516c-4.495.006-5.436-2.055-5.436-3.784z"
                    fill="#83cd29"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="32"
                    height="32"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item figma">
              <a
                href="https://www.figma.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 24 24"
                >
                  <g fill="none" fill-rule="evenodd" transform="translate(4)">
                    <circle cx="12" cy="12" r="4" fill="#19BCFE" />
                    <path
                      fill="#09CF83"
                      d="M4 24a4 4 0 0 0 4-4v-4H4a4 4 0 1 0 0 8z"
                    />
                    <path fill="#A259FF" d="M4 16h4V8H4a4 4 0 1 0 0 8z" />
                    <path fill="#F24E1E" d="M4 8h4V0H4a4 4 0 1 0 0 8z" />
                    <path fill="#FF7262" d="M12 8H8V0h4a4 4 0 1 1 0 8z" />
                  </g>
                  <rect
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item gatsby">
              <a
                href="https://www.gatsbyjs.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 256 256"
                >
                  <path
                    d="M128 0C57.308 0 0 57.307 0 128s57.308 128 128 128c70.693 0 128-57.307 128-128S198.693 0 128 0zM27.504 129.334l99.161 99.162c-54.45-.71-98.452-44.71-99.161-99.162zm122.992 96.65l-120.48-120.48C40.234 60.824 80.223 27.487 128 27.487c33.397 0 62.985 16.293 81.263 41.36l-13.917 12.279C180.52 59.864 155.886 45.949 128 45.949c-35.505 0-65.74 22.552-77.169 54.113L155.94 205.169c25.525-9.243 45.156-30.79 51.73-57.477h-43.566V128h64.41c0 47.778-33.336 87.767-78.017 97.983z"
                    fill="#744C9E"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="256"
                    height="256"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item mongo">
              <a
                href="https://www.mongodb.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 32 32"
                >
                  <defs>
                    <linearGradient
                      id="IconifyId-1751e036479-b16b68-86"
                      x1="-645.732"
                      y1="839.188"
                      x2="-654.59"
                      y2="839.25"
                      gradientTransform="matrix(-.977 -.323 -.29 .877 -375.944 -928.287)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset=".231" stop-color="#999875" />
                      <stop offset=".563" stop-color="#9b9977" />
                      <stop offset=".683" stop-color="#a09f7e" />
                      <stop offset=".768" stop-color="#a9a889" />
                      <stop offset=".837" stop-color="#b7b69a" />
                      <stop offset=".896" stop-color="#c9c7b0" />
                      <stop offset=".948" stop-color="#deddcb" />
                      <stop offset=".994" stop-color="#f8f6eb" />
                      <stop offset="1" stop-color="#fbf9ef" />
                    </linearGradient>
                    <linearGradient
                      id="IconifyId-1751e036479-b16b68-87"
                      x1="-644.287"
                      y1="823.405"
                      x2="-657.028"
                      y2="845.476"
                      gradientTransform="matrix(-.977 -.323 -.29 .877 -375.944 -928.287)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0" stop-color="#48a547" />
                      <stop offset="1" stop-color="#3f9143" />
                    </linearGradient>
                    <linearGradient
                      id="IconifyId-1751e036479-b16b68-88"
                      x1="-643.386"
                      y1="839.485"
                      x2="-652.418"
                      y2="833.417"
                      gradientTransform="matrix(-.977 -.323 -.29 .877 -375.944 -928.287)"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0" stop-color="#41a247" />
                      <stop offset=".352" stop-color="#4ba74b" />
                      <stop offset=".956" stop-color="#67b554" />
                      <stop offset="1" stop-color="#69b655" />
                    </linearGradient>
                  </defs>
                  <path
                    d="M16.62 30l-.751-.249s.1-3.8-1.275-4.067c-.9-1.048.133-44.741 3.423-.149a2.712 2.712 0 0 0-1.333 1.523A14.1 14.1 0 0 0 16.62 30z"
                    fill="url(#IconifyId-1751e036479-b16b68-86)"
                  />
                  <path
                    d="M17.026 26.329a13.223 13.223 0 0 0 5-13.225c-1.47-6.485-4.951-8.617-5.326-9.431a9.792 9.792 0 0 1-.825-1.6l.277 18.069s-.574 5.522.874 6.187z"
                    fill="url(#IconifyId-1751e036479-b16b68-87)"
                  />
                  <path
                    d="M15.487 26.569S9.366 22.4 9.72 15.025a15.54 15.54 0 0 1 5.519-11.648A1.725 1.725 0 0 0 15.846 2c.381.82.319 12.243.359 13.579c.155 5.197-.289 10.009-.718 10.99z"
                    fill="url(#IconifyId-1751e036479-b16b68-88)"
                  />
                  <rect
                    x="0"
                    y="0"
                    width="32"
                    height="32"
                    fill="rgba(0, 0, 0, 0)"
                  />
                </svg>
              </a>
            </li>
            <li className="list-inline-item bootstrap">
              <a
                href="https://getbootstrap.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={bootstrap} className="item" alt="Bootstrap" />
              </a>
            </li>
            <li className="list-inline-item express">
              <a
                href="https://expressjs.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={express} className="item" alt="Express" />
              </a>
            </li>
            <li className="list-inline-item grunt">
              <a
                href="https://gruntjs.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={grunt} className="item" alt="Grunt" />
              </a>
            </li>
            <li className="list-inline-item jasmine">
              <a
                href="https://jasmine.github.io/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={jasmine} className="item" alt="Jasmine" />
              </a>
            </li>

            <li className="list-inline-item list-inline-item-100 knockout">
              <a
                href="https://knockoutjs.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={knockout} className="item" alt="Knockout" />
              </a>
            </li>
            <li className="list-inline-item redux">
              <a
                href="https://redux.js.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={redux} className="item" alt="Redux" />
              </a>
            </li>
            <li className="list-inline-item selenium">
              <a
                href="https://www.selenium.dev/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={selenium} className="item" alt="Selenium" />
              </a>
            </li>
            <li className="list-inline-item webpack">
              <a
                href="https://webpack.js.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={webpack} className="item" alt="Webpack" />
              </a>
            </li>
            <li className="list-inline-item docker">
              <a
                href="https://www.docker.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={docker} className="item" alt="Docker" />
              </a>
            </li>
            <li className="list-inline-item list-inline-item-90 jquery">
              <a
                href="https://jquery.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={jquery} className="item" alt="Jquery" />
              </a>
            </li>
          </ul>

          <div className="subheading mb-3">Workflow</div>
          <ul className="fa-ul mb-0">
            <li>
              <i className="fa-li fa fa-check"></i>
              Develop highly responsive, scalable and cross browser compatible
              web applications
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Consulting and troubleshooting support for all the adoption teams
              in the department.
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Monitoring website performance and rectifying issues and providing
              hotfixes for clients.
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Participation in Code reviews and Design discussions.
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Developing utilities and generic reusable solutions used across
              applications
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Cross Browser Testing &amp; Debugging
            </li>

            <li>
              <i className="fa-li fa fa-check"></i>
              Platform Integration testing &amp; Debugging
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Agile Development &amp; Scrum
            </li>
          </ul>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="awards"
      >
        <div className="w-100">
          <h2 className="mb-5">Awards</h2>
          <ul className="fa-ul mb-0">
            <li className="mb-3">
              <i className="fa-li fa fa-trophy text-warning"></i>
              <b>Best performer</b> –{' '}
              <b>
                <span className="text-primary">Q2’18.</span>
              </b>
            </li>
            <li className="mb-3">
              <i className="fa-li fa fa-trophy text-warning"></i>
              <b>Best Team in the organization</b> –
              <b>
                <span className="text-primary">Q1’19.</span>
              </b>
            </li>
            <li className="mb-3">
              <i className="fa-li fa fa-trophy text-warning"></i>
              <b>Best performer</b> –{' '}
              <b>
                <span className="text-primary">Q1’19.</span>
              </b>
            </li>
            <li className="mb-3">
              <i className="fa-li fa fa-trophy text-warning"></i>
              <b>Bug Bash Content Winner</b> –{' '}
              <b>
                <span className="text-primary">Q2’20.</span>
              </b>
            </li>
          </ul>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="experience"
      >
        <div className="w-100">
          <h2 className="mb-5">PROFESSIONAL EXPERIENCE</h2>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between">
            <div className="resume-content">
              <p style={{ marginBottom: '0px' }}>
                <b>ORACLE, Hyderabad – </b> Member of Technical Staff
              </p>
              <p className="date_grey_bold">March 2021 - PRESENT</p>
            </div>
          </div>
          <div className="resume-item d-flex flex-column flex-md-row justify-content-between ">
            <div className="resume-content">
              <p style={{ marginBottom: '0px' }}>
                <b>Pega Systems, Hyderabad – </b> Front End Developer{' '}
              </p>
              <p className="date_grey_bold">July 2017 – February 2021</p>
            </div>
          </div>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex justify-content-center"
        id="project_profile"
      >
        <div className="w-100">
          <h2 className="mb-5">Project profile</h2>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">
            <div className="resume-content">
              <h3 className="mb-0">
                ORACLE, Hyderabad -{' '}
                <span className="text-primary">Member of Technical Staff</span>
              </h3>
              <p>
                <b>Skills Used:</b> Oracle JET, JavaScript, Knockout JS, Require
                JS, HTML5, SCSS, jQuery, React JS, Selenium, Jasmine, Jest, DOM,
                REST API, JSON, MVVM Pattern.
              </p>
              <p>
                <b>Projects:</b> Pack, Landing Page API
              </p>
              <p>
                <b>Roles and Responsibilities:</b>
                <ul>
                  <li>
                    Developed responsive, accessible and scalable JET components
                    and React UI components.
                  </li>
                  <li>
                    Integration of the components into different applications.
                  </li>
                  <li>
                    Test Automation suits using Jasmine, Jest and Selenium.
                  </li>
                  <li>
                    Assisting on usability and accessibility of various
                    features.
                  </li>
                  <li>
                    Provide support for Adoption teams, Participation in Code
                    reviews and Design discussions.
                  </li>
                  <li>
                    Running AUDIT, CVE security issues on various applications
                    and fixing them.
                  </li>
                </ul>
              </p>
            </div>
            <div className="resume-date text-md-right">
              <span className="date_grey_bold">March 2021 – Present</span>
            </div>
          </div>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between mb-5">
            <div className="resume-content">
              <h3 className="mb-0">
                Pega Systems, Hyderabad -{' '}
                <span className="text-primary">Front End Developer</span>
              </h3>
              <div>
                <h3>REACT COSMOS</h3>
                <p>
                  <b>Skills Used:</b> REACT, Typescript, Styled components,
                  JEST, GIT.
                </p>
                <p>
                  <b>Roles and Responsibilities:</b>
                  <ul>
                    <li>
                      Building reusable responsive UI components using REACT and
                      Styled Components. Integration in container components (
                      Storybook ). Type checking using TYPESCRIPT.
                    </li>
                    <li>
                      Unit test for the components using JEST. Reviewing the
                      code and participation in design discussions.
                    </li>
                    <li>
                      Provide support for Adoption teams, Participation in Code
                      reviews and Design discussions.
                    </li>
                    <li>
                      Consulting and troubleshooting support for all the
                      adoption teams in the department.
                    </li>
                  </ul>
                </p>
              </div>
              <div>
                <h3>FSM DISPATCHER PORTAL</h3>
                <p>
                  <b>Skills Used:</b> Google Maps API, Vis JS, Moment JS, Design
                  patterns, Prototype, JavaScript, JSON.
                </p>
                <p>
                  <b>Roles and Responsibilities:</b>
                  <ul>
                    <li>
                      Building highly scalable responsive and interactive web
                      portal using JavaScript and CSS.
                    </li>
                    <li>
                      Integrating Google Maps API and customization as per
                      business requirement.
                    </li>
                    <li>
                      Used Moment JS for date component which is used to sync
                      data for different time zones.
                    </li>
                    <li>
                      Responsible for timeline views for the work orders using
                      Vis JS.
                    </li>
                  </ul>
                </p>
              </div>
              <div>
                <h3>CUSTOMER SERVICE AND GCS PORTAL</h3>
                <p>
                  <b>Skills Used:</b> JavaScript, PRPC, jQuery, JavaScript
                  libraries, HTML, CSS.
                </p>
                <p>
                  <b>Roles and Responsibilities:</b>
                  <ul>
                    <li>
                      Part of two member team, responsible for UI Refactoring -
                      Revamping the entire old portal using best practices of
                      JavaScript, PRPC.
                    </li>
                    <li>
                      Implemented Custom controls, Timeline views using
                      JavaScript and jQuery.
                    </li>
                    <li>
                      Integration of Notification channels, CK Editor plugins
                      using PRPC and JavaScript libraries.
                    </li>
                    <li>
                      Monitoring website performance and fixing issues and
                      providing hotfixes to the client.
                    </li>
                  </ul>
                </p>
              </div>
            </div>
            <div className="resume-date text-md-right">
              <span className="date_grey_bold">July 2017 – February 2021</span>
            </div>
          </div>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="pilot_projects"
      >
        <div className="w-100">
          <h2 className="mb-5">Pilot projects</h2>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-between">
            <div className="resume-content">
              <p>
                <b>Ecommerce application [Online T-shirt store]</b> – built
                using MERN stack{' '}
                <a
                  href="https://kante-srikanth.github.io/MERN-Application/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>Git URL</b>
                </a>
              </p>
            </div>
          </div>
          <div className="resume-item d-flex flex-column flex-md-row justify-content-between ">
            <div className="resume-content">
              <p>
                <b>React chat component</b> – built using React{' '}
                <a
                  href="https://kante-srikanth.github.io/React-chat-component/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>Git URL</b>
                </a>
              </p>
            </div>
          </div>
          <div className="resume-item d-flex flex-column flex-md-row justify-content-between ">
            <div className="resume-content">
              <p>
                <b>Live chat</b> – built using Javascript, Express and
                Sockets.io{' '}
                <a
                  href="https://kante-srikanth.github.io/Live-chat/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>Git URL</b>
                </a>
              </p>
            </div>
          </div>
          <div className="resume-item d-flex flex-column flex-md-row justify-content-between ">
            <div className="resume-content">
              <p>
                <b>Chrome extension</b> – built using Chrome APIs, JS, HTML, CSS{' '}
                <a
                  href="https://kante-srikanth.github.io/Chrome-extension/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>Git URL</b>
                </a>
              </p>
            </div>
          </div>
          <div className="resume-item d-flex flex-column flex-md-row justify-content-between ">
            <div className="resume-content">
              <p>
                <b>Teams Messenger</b> – built using React, Context API, Hooks,
                Material, Socket.io{' '}
                <a
                  href="https://kante-srikanth.github.io/Teams-messenger/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b>Git URL</b>
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="education_interests"
      >
        <div className="w-100">
          <h2 className="mb-5">Education</h2>

          <div className="resume-item d-flex flex-column flex-md-row justify-content-start mb-5">
            <div className="resume-content">
              <h3 className="mb-0">Vasavi College of Engineering</h3>
              <div className="subheading mb-3">Bachelor of Engineering</div>
              <div>Computer Science &amp; Engineering - 80%</div>
            </div>
            <div className="resume-date text-md-right">
              <b>
                <span className="text-primary">July 2013 - May 2017</span>
              </b>
            </div>
          </div>

          <h2 className="mb-5">Interests</h2>
          <ul className=" mb-0 interest-item-wrapper">
            <li className="mb-3 interest-item">
              <img src={sports} className="item" alt="sports" />
              <p className="pl-3">Sports</p>
            </li>
            <li className="mb-3 interest-item">
              <img src={surfing} className="item" alt="sports" />
              <p className="pl-3">Browsing Internet</p>
            </li>
            <li className="mb-3 interest-item">
              <img src={music} className="item" alt="sports" />
              <p className="pl-3">Listening Music</p>
            </li>
            <li className="mb-3 interest-item">
              <img src={gadget} className="item" alt="sports" />
              <p className="pl-3">
                Gadgets{' '}
                <span role="img" aria-label="love">
                  ❤️
                </span>
              </p>
            </li>
            <li className="mb-3 interest-item">
              <img src={travel} className="item" alt="sports" />
              <p className="pl-3">Travelling</p>
            </li>
          </ul>
        </div>
      </section>
    </div>
  </Layout>
);

export default IndexPage;
